import { Navigate } from "react-router-dom";
import AuthAppleSetup from "../pages/AuthAppleSetup";
import AuthLinkedInCallback from "../pages/AuthLinkedInCallback";
import AuthLogin from "../pages/AuthLogin";
import AuthRecoverRequest from "../pages/AuthRecoverRequest";
import AuthRecoverReset from "../pages/AuthRecoverReset";
import AuthRecoverSuccess from "../pages/AuthRecoverSuccess";
import AuthRecoverVerify from "../pages/AuthRecoverVerify";
import LandingPage from "../pages/care/LandingPage";
import VehicleDetailPage from "../pages/care/VehicleDetailPage";

export const publicRoutes = [
  { path: "/", element: <LandingPage /> },
  { path: "/inventory/:vehicleId", element: <VehicleDetailPage publicMode /> },
  { path: "/login", element: <AuthLogin /> },
  { path: "/book-a-demo", element: <Navigate to="/" replace /> },
  { path: "/get-started", element: <Navigate to="/" replace /> },
  { path: "/auth/signup", element: <Navigate to="/login" replace /> },
  { path: "/auth/linkedin/callback", element: <AuthLinkedInCallback /> },
  { path: "/auth/apple-setup", element: <AuthAppleSetup /> },
  { path: "/auth/social-setup", element: <AuthAppleSetup /> },
  { path: "/auth/forgot-password", element: <Navigate to="/auth/recover" replace /> },
  { path: "/auth/recover", element: <AuthRecoverRequest /> },
  { path: "/auth/verify", element: <AuthRecoverVerify /> },
  { path: "/auth/reset", element: <AuthRecoverReset /> },
  { path: "/auth/recovered", element: <AuthRecoverSuccess /> },
  { path: "/auth/session-expired", element: <AuthLogin /> },
  { path: "/auth/logout", element: <Navigate to="/login" replace /> },
  { path: "/privacy-policy", element: <Navigate to="/" replace /> },
];
